module.exports = __webpack_public_path__ + "r-v3/img/sticker_13.1049674c.svg";